import { render, staticRenderFns } from "./userCenter.vue?vue&type=template&id=4183b17c&scoped=true"
import script from "./userCenter.vue?vue&type=script&lang=js"
export * from "./userCenter.vue?vue&type=script&lang=js"
import style0 from "./userCenter.vue?vue&type=style&index=0&id=4183b17c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4183b17c",
  null
  
)

export default component.exports